// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
iframe#webpack-dev-server-client-overlay{display:none!important}


/* General Container */
.app-container {
  background: linear-gradient(to bottom, #f6e1e1, #c9e8f4);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

body {
  overflow: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
}

.cardsContainer {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  padding-left: 5px; /* Add padding to the container */
  padding-right: 5px; /* Add padding to the container */
}

/* Ensure the cards are responsive */
/* .ant-col {
  display: flex;
  justify-content: center;
} */

.address-text {
  display: inline-block; /* Ensure the span behaves like a block element */
  max-width: 50vw; /* Adjust this value based on your design */
  white-space: nowrap; /* Prevent text from wrapping */
  overflow: hidden; /* Hide overflow */
  text-overflow: ellipsis; /* Show ellipsis when text overflows */
}

.addressHeaderContainer {
  padding: 0px 3px;
}

/* Media query for mobile devices */
@media (max-width: 768px) {

  .header-container {
    padding: 8px 12px; /* Reduce padding for smaller screens */
    height: 48px; /* Slightly reduce height for mobile */
  }

  .address-text {
    font-size: 18px !important; /* Smaller font size for mobile */
    max-width: 38vw; /* Adjust for smaller screens */
  }

  .addressHeaderContainer {
    padding: 0px 3px;
    height: 100%;
    font-size: 25px;
  }

  .menu-button,
  .back-button,
  .refresh-button {
    font-size: 25px !important; /* Adjust icon size for mobile */
    height: 100%;
    width: 15%;
  }

  .show-banner-button {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .header-content {
    height: 100%;
    gap: 4px; /* Reduce gap between items for mobile */
  }
}

/* Header */
.header-container {
  background-color: #0077b6; /* Bright blue */
  color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  padding: 5px;
}

.header-content {
  justify-content: space-between;
  align-items: center;
}

.menu-button {
  color: white;
  background-color: #c8e3ed; /* Lighter blue */
}

/* Sidebar Drawer */
.ant-drawer-body {
  padding: 9px !important;
  background: linear-gradient(to bottom, #ffddc1, #ffab91);
}

.ant-btn-text {
  color: #0077b6;
}

/* Queue Card */
.queue-card {
  height: 100%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  border-radius: 10px;
  transition: transform 0.3s ease-in-out;
}

.status-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-top: 7px;
}

.active {
  color: #4caf50; /* Green */
  font-style: italic;
  /* margin-top: -10px; */
}

.inactive {
  color: #f44336; /* Red */
  font-style: italic;
  /* margin-top: -10px; */
}

/* Queue Management Panel */
.queue-management-panel {
  padding: 5px;
  background-color: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  max-width: 95%;
  margin: 0 auto;
  border-radius: 10px;
}

.queue-management-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.queue-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #0077b6;
}

.section-title {
  font-weight: 600;
  font-size: 16px;
}

.number-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.current-number {
  font-size: 24px;
  font-weight: 600;
}

.reset-button {
  /* width: 50px; */
  font-weight: 600;
  background-color: #f44336; /* Red */
  color: white;
  border: none;
  float: right;
  margin-left: 10px;
  margin-bottom: 5px;
}

.timeArea {
  font-size: 10px;
  float: right;
  margin-top: -20px;
}

.selALertBtn {
  float: right;
  margin-top: 10px;
  background-color: #ff9800; /* Orange */
  border: none;
  color: white;
}

/* Button Styles */
.ant-btn-primary {
  background-color: #0077b6; /* Bright blue */
  border-color: #0077b6;
}

.ant-btn-primary:hover {
  background-color: #0096c7; /* Lighter blue */
  border-color: #0096c7;
}

.ant-btn-default {
  background-color: #ff9800; /* Orange */
  color: white;
}

.ant-btn-danger {
  background-color: #f44336; /* Red */
  color: white;
}

.ant-btn-danger:hover {
  background-color: #d32f2f; /* Darker red */
}

/* Modal Styles */
.ant-modal-header {
  background-color: #0077b6; /* Bright blue */
  color: white;
}

.ant-modal-footer {
  background-color: #f1f1f1;
}

.ant-modal-title {
  color: #fff;
}

.ant-modal-body {
  background-color: #f1f1f1;
}

/* Location Modal */
.ant-modal-body {
  padding: 20px;
}

/* Main Content */
.main-content {
  /* margin-top: 10px; */
  /* padding-top: 100px;  */
}

/* Header */
.header-container {
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 5px;
  position: sticky;
  min-height: 33px;
  /* position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000; */
}

.header-content {
  justify-content: space-between;
  align-items: center;
}

.menu-button {
  float: right;
}

.refresh-button {
  float: right;
}
/* Location Modal */
.modal-body {
  padding: 20px;
}

.status-indicator.active {
  background-color: #00cc66;
}

.status-indicator.inactive {
  background-color: #ff6b6b;
}

.queue-card-header {
  display: flex;
  justify-content: space-between;
  /* align-items: center; */
  color: #0077b6; /* Bright blue */
  margin-top: -10px;
}

.businessHeadingClass {
  font-size: 18px;
  width: 75%;
}

.pinCodeClass {
  font-size: 12px;
  font-style: italic;
}

.queue-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
}

.queue-info .queue-info-right {
  text-align: right;
}

.business-type-card {
  cursor: pointer; /* Add pointer cursor to indicate clickable cards */
  text-align: center;
  padding: 10px; /* Reduce padding */
  transition: transform 0.2s;
  height: 100%; /* Ensure cards take full height of the column */
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.business-type-card:hover {
  transform: scale(1.05); /* Add a slight scale effect on hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Optional: Add a shadow on hover */
}

.results-header {
  margin-bottom: 2px;
  border-bottom: 1px solid #f0f0f0;
}

/* For the empty state */
.ant-empty {
  padding: 0;
}

.ant-empty-image {
  height: 60px;
  margin-bottom: 16px;
}

.search-bar-container {
  margin-top: 6px;
  display: flex;
  align-items: center; /* Align items vertically in the center */
  justify-content: space-between; /* Space between search bar and switch */
}

.switch-container {
  display: flex;
  flex-direction: column; /* Stack items vertically */
  align-items: center; /* Center items horizontally */
  margin-left: 16px; /* Add some spacing between the search bar and the switch */
  margin-right: 8px;
}

.favorites-text {
  font-size: 10px;
}

.HeaderContent {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000; /* Ensure it stays above other content */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Optional: Add a shadow for better separation */
}

.scrollable-row {
  overflow-y: auto; /* Enable vertical scrolling */
  max-height: calc(100vh - 127px); /* Set a max height for the row */
}


.crossIconParent {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px; /* Circle size */
  height: 25px; /* Circle size */
  border-radius: 50%; /* Makes it circular */
  background-color: rgb(245, 192, 192); /* Light red background */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); /* Shadow */
  cursor: pointer; /* Show pointer on hover */
}







/* Queue Management Panel Styles */
.queue-management-panel {
  padding: 8px;
  background-color: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  max-width: 97%;
  margin: 0 auto;
  border-radius: 12px;
  border: none;
}

.queue-management-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.section-label {
  display: block;
  margin-bottom: 8px;
  color: #34495e;
  font-size: 15px;
}

/* Number Display Section */
.number-display-section {
  text-align: center;
}

.number-display {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 12px;
}

.current-number-display {
  min-width: 100px;
  /* width: 120px; */
  /* height: 120px; */
  background-color: #f8f9fa;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.current-number-display span {
  font-size: 48px;
  font-weight: 700;
  color: #2c3e50;
}

/* Clinic Status Section */
.clinic-status-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.status-control {
  display: flex;
  flex-direction: column;
}

.reset-button {
  height: 40px;
  font-weight: 500;
  background-color: #f8f9fa;
  color: #e74c3c;
  border: 1px solid #e74c3c;
  border-radius: 8px;
}

/* Message Section */
/* .message-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* .active-message {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 12px;
}

.message-content {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.message-close {
  color: #e74c3c;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  transition: background-color 0.2s;
}

/* .message-close:hover {
  background-color: #f5e0e0;
}

.message-text {
  flex: 1;
  color: #2c3e50;
}

.message-time {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  text-align: right;
} */

/* Business Type List Styles */
.business-type-container {
  padding: 20px;
  max-width: 100%;
  margin: 0 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.section-title {
  color: #2c3e50;
  margin-bottom: 16px;
  font-weight: 500;
  text-align: center;
}

.scrollable-row-container {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px;
}

.scrollable-row1 {
  display: flex;
  flex-wrap: wrap;
  margin: -8px !important; /* Counteract the gutter */
}

/* Fix for antd Row/Col with scrolling */
.scrollable-row1 > .ant-col {
  padding: 8px !important; /* Recreate gutter */
}

.business-type-card {
  cursor: pointer;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
  transition: all 0.3s ease;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
}

.business-type-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  border-color: #1890ff;
}

.card-content1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  width: 100%;
  margin-left: -15px;
}

.business-icon {
  font-size: 32px !important;
  color: #1890ff;
  margin-bottom: 12px;
  padding: 8px;
  background-color: #e6f7ff;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.business-title {
  color: #2c3e50;
  font-size: 16px;
  text-align: center;
  margin-top: 8px;
  word-break: break-word;
}

/* Custom scrollbar styling */
.scrollable-row-container::-webkit-scrollbar {
  width: 8px;
}

.scrollable-row-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.scrollable-row-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.scrollable-row-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .business-icon {
    font-size: 28px !important;
    width: 50px;
    height: 50px;
  }
  
  .business-title {
    font-size: 14px;
  }
}

@media (min-width: 768px) {
  .queue-management-panel {
    max-width: 60%;
  }
  .results-header {
    max-width: 60%;
    /* margin-left: 20%; */
  }
}
@media (min-width: 1024px) {
  .queue-management-panel {
    max-width: 60%;
  }
  .results-header {
    max-width: 60%;
    /* margin-left: 20%; */
  }
}
@media (min-width: 1440px) {
  .queue-management-panel {
    max-width: 60%;
  }
  .results-header {
    max-width: 60%;
    /* margin-left: 20%; */
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA,yCAAyC,sBAAsB;;;AAG/D,sBAAsB;AACtB;EACE,wDAAwD;EACxD,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4DAA4D;EAC5D,iBAAiB,EAAE,iCAAiC;EACpD,kBAAkB,EAAE,iCAAiC;AACvD;;AAEA,oCAAoC;AACpC;;;GAGG;;AAEH;EACE,qBAAqB,EAAE,iDAAiD;EACxE,eAAe,EAAE,2CAA2C;EAC5D,mBAAmB,EAAE,+BAA+B;EACpD,gBAAgB,EAAE,kBAAkB;EACpC,uBAAuB,EAAE,sCAAsC;AACjE;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;;EAEE;IACE,iBAAiB,EAAE,uCAAuC;IAC1D,YAAY,EAAE,sCAAsC;EACtD;;EAEA;IACE,0BAA0B,EAAE,iCAAiC;IAC7D,eAAe,EAAE,+BAA+B;EAClD;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;;EAEA;;;IAGE,0BAA0B,EAAE,gCAAgC;IAC5D,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,QAAQ,EAAE,wCAAwC;EACpD;AACF;;AAEA,WAAW;AACX;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,YAAY;EACZ,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,wDAAwD;AAC1D;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc,EAAE,UAAU;EAC1B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc,EAAE,QAAQ;EACxB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,yBAAyB;EACzB,yCAAyC;EACzC,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB,EAAE,QAAQ;EACnC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB,EAAE,WAAW;EACtC,YAAY;EACZ,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,WAAW;EACtC,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,QAAQ;EACnC,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,eAAe;AAC5C;;AAEA,iBAAiB;AACjB;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB;;;;kBAIgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA,mBAAmB;AACnB;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,cAAc,EAAE,gBAAgB;EAChC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe,EAAE,mDAAmD;EACpE,kBAAkB;EAClB,aAAa,EAAE,mBAAmB;EAClC,0BAA0B;EAC1B,YAAY,EAAE,gDAAgD;EAC9D,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB,EAAE,uCAAuC;EAC/D,wCAAwC,EAAE,oCAAoC;AAChF;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB,EAAE,yCAAyC;EAC9D,8BAA8B,EAAE,wCAAwC;AAC1E;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,2BAA2B;EACnD,mBAAmB,EAAE,8BAA8B;EACnD,iBAAiB,EAAE,2DAA2D;EAC9E,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa,EAAE,wCAAwC;EACvD,wCAAwC,EAAE,iDAAiD;AAC7F;;AAEA;EACE,gBAAgB,EAAE,8BAA8B;EAChD,+BAA+B,EAAE,iCAAiC;AACpE;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,gBAAgB;EAC7B,YAAY,EAAE,gBAAgB;EAC9B,kBAAkB,EAAE,sBAAsB;EAC1C,oCAAoC,EAAE,yBAAyB;EAC/D,yCAAyC,EAAE,WAAW;EACtD,eAAe,EAAE,0BAA0B;AAC7C;;;;;;;;AAQA,kCAAkC;AAClC;EACE,YAAY;EACZ,yBAAyB;EACzB,yCAAyC;EACzC,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAwCG;;AAEH,8BAA8B;AAC9B;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB,EAAE,0BAA0B;AACrD;;AAEA,wCAAwC;AACxC;EACE,uBAAuB,EAAE,oBAAoB;AAC/C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;IAC1B,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,sBAAsB;EACxB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,sBAAsB;EACxB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,sBAAsB;EACxB;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\niframe#webpack-dev-server-client-overlay{display:none!important}\n\n\n/* General Container */\n.app-container {\n  background: linear-gradient(to bottom, #f6e1e1, #c9e8f4);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\nbody {\n  overflow: hidden;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n}\n\n.cardsContainer {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  padding-left: 5px; /* Add padding to the container */\n  padding-right: 5px; /* Add padding to the container */\n}\n\n/* Ensure the cards are responsive */\n/* .ant-col {\n  display: flex;\n  justify-content: center;\n} */\n\n.address-text {\n  display: inline-block; /* Ensure the span behaves like a block element */\n  max-width: 50vw; /* Adjust this value based on your design */\n  white-space: nowrap; /* Prevent text from wrapping */\n  overflow: hidden; /* Hide overflow */\n  text-overflow: ellipsis; /* Show ellipsis when text overflows */\n}\n\n.addressHeaderContainer {\n  padding: 0px 3px;\n}\n\n/* Media query for mobile devices */\n@media (max-width: 768px) {\n\n  .header-container {\n    padding: 8px 12px; /* Reduce padding for smaller screens */\n    height: 48px; /* Slightly reduce height for mobile */\n  }\n\n  .address-text {\n    font-size: 18px !important; /* Smaller font size for mobile */\n    max-width: 38vw; /* Adjust for smaller screens */\n  }\n\n  .addressHeaderContainer {\n    padding: 0px 3px;\n    height: 100%;\n    font-size: 25px;\n  }\n\n  .menu-button,\n  .back-button,\n  .refresh-button {\n    font-size: 25px !important; /* Adjust icon size for mobile */\n    height: 100%;\n    width: 15%;\n  }\n\n  .show-banner-button {\n    height: 100%;\n    display: flex;\n    align-items: center;\n  }\n\n  .header-content {\n    height: 100%;\n    gap: 4px; /* Reduce gap between items for mobile */\n  }\n}\n\n/* Header */\n.header-container {\n  background-color: #0077b6; /* Bright blue */\n  color: white;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  padding: 5px;\n}\n\n.header-content {\n  justify-content: space-between;\n  align-items: center;\n}\n\n.menu-button {\n  color: white;\n  background-color: #c8e3ed; /* Lighter blue */\n}\n\n/* Sidebar Drawer */\n.ant-drawer-body {\n  padding: 9px !important;\n  background: linear-gradient(to bottom, #ffddc1, #ffab91);\n}\n\n.ant-btn-text {\n  color: #0077b6;\n}\n\n/* Queue Card */\n.queue-card {\n  height: 100%;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  background-color: #ffffff;\n  border-radius: 10px;\n  transition: transform 0.3s ease-in-out;\n}\n\n.status-indicator {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  margin-top: 7px;\n}\n\n.active {\n  color: #4caf50; /* Green */\n  font-style: italic;\n  /* margin-top: -10px; */\n}\n\n.inactive {\n  color: #f44336; /* Red */\n  font-style: italic;\n  /* margin-top: -10px; */\n}\n\n/* Queue Management Panel */\n.queue-management-panel {\n  padding: 5px;\n  background-color: #ffffff;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  max-width: 95%;\n  margin: 0 auto;\n  border-radius: 10px;\n}\n\n.queue-management-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.queue-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #0077b6;\n}\n\n.section-title {\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.number-controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.current-number {\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.reset-button {\n  /* width: 50px; */\n  font-weight: 600;\n  background-color: #f44336; /* Red */\n  color: white;\n  border: none;\n  float: right;\n  margin-left: 10px;\n  margin-bottom: 5px;\n}\n\n.timeArea {\n  font-size: 10px;\n  float: right;\n  margin-top: -20px;\n}\n\n.selALertBtn {\n  float: right;\n  margin-top: 10px;\n  background-color: #ff9800; /* Orange */\n  border: none;\n  color: white;\n}\n\n/* Button Styles */\n.ant-btn-primary {\n  background-color: #0077b6; /* Bright blue */\n  border-color: #0077b6;\n}\n\n.ant-btn-primary:hover {\n  background-color: #0096c7; /* Lighter blue */\n  border-color: #0096c7;\n}\n\n.ant-btn-default {\n  background-color: #ff9800; /* Orange */\n  color: white;\n}\n\n.ant-btn-danger {\n  background-color: #f44336; /* Red */\n  color: white;\n}\n\n.ant-btn-danger:hover {\n  background-color: #d32f2f; /* Darker red */\n}\n\n/* Modal Styles */\n.ant-modal-header {\n  background-color: #0077b6; /* Bright blue */\n  color: white;\n}\n\n.ant-modal-footer {\n  background-color: #f1f1f1;\n}\n\n.ant-modal-title {\n  color: #fff;\n}\n\n.ant-modal-body {\n  background-color: #f1f1f1;\n}\n\n/* Location Modal */\n.ant-modal-body {\n  padding: 20px;\n}\n\n/* Main Content */\n.main-content {\n  /* margin-top: 10px; */\n  /* padding-top: 100px;  */\n}\n\n/* Header */\n.header-container {\n  background-color: white;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 5px;\n  position: sticky;\n  min-height: 33px;\n  /* position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000; */\n}\n\n.header-content {\n  justify-content: space-between;\n  align-items: center;\n}\n\n.menu-button {\n  float: right;\n}\n\n.refresh-button {\n  float: right;\n}\n/* Location Modal */\n.modal-body {\n  padding: 20px;\n}\n\n.status-indicator.active {\n  background-color: #00cc66;\n}\n\n.status-indicator.inactive {\n  background-color: #ff6b6b;\n}\n\n.queue-card-header {\n  display: flex;\n  justify-content: space-between;\n  /* align-items: center; */\n  color: #0077b6; /* Bright blue */\n  margin-top: -10px;\n}\n\n.businessHeadingClass {\n  font-size: 18px;\n  width: 75%;\n}\n\n.pinCodeClass {\n  font-size: 12px;\n  font-style: italic;\n}\n\n.queue-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 600;\n}\n\n.queue-info .queue-info-right {\n  text-align: right;\n}\n\n.business-type-card {\n  cursor: pointer; /* Add pointer cursor to indicate clickable cards */\n  text-align: center;\n  padding: 10px; /* Reduce padding */\n  transition: transform 0.2s;\n  height: 100%; /* Ensure cards take full height of the column */\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.business-type-card:hover {\n  transform: scale(1.05); /* Add a slight scale effect on hover */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Optional: Add a shadow on hover */\n}\n\n.results-header {\n  margin-bottom: 2px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n/* For the empty state */\n.ant-empty {\n  padding: 0;\n}\n\n.ant-empty-image {\n  height: 60px;\n  margin-bottom: 16px;\n}\n\n.search-bar-container {\n  margin-top: 6px;\n  display: flex;\n  align-items: center; /* Align items vertically in the center */\n  justify-content: space-between; /* Space between search bar and switch */\n}\n\n.switch-container {\n  display: flex;\n  flex-direction: column; /* Stack items vertically */\n  align-items: center; /* Center items horizontally */\n  margin-left: 16px; /* Add some spacing between the search bar and the switch */\n  margin-right: 8px;\n}\n\n.favorites-text {\n  font-size: 10px;\n}\n\n.HeaderContent {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000; /* Ensure it stays above other content */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Optional: Add a shadow for better separation */\n}\n\n.scrollable-row {\n  overflow-y: auto; /* Enable vertical scrolling */\n  max-height: calc(100vh - 127px); /* Set a max height for the row */\n}\n\n\n.crossIconParent {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px; /* Circle size */\n  height: 25px; /* Circle size */\n  border-radius: 50%; /* Makes it circular */\n  background-color: rgb(245, 192, 192); /* Light red background */\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); /* Shadow */\n  cursor: pointer; /* Show pointer on hover */\n}\n\n\n\n\n\n\n\n/* Queue Management Panel Styles */\n.queue-management-panel {\n  padding: 8px;\n  background-color: #ffffff;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  max-width: 97%;\n  margin: 0 auto;\n  border-radius: 12px;\n  border: none;\n}\n\n.queue-management-content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.section-label {\n  display: block;\n  margin-bottom: 8px;\n  color: #34495e;\n  font-size: 15px;\n}\n\n/* Number Display Section */\n.number-display-section {\n  text-align: center;\n}\n\n.number-display {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin-top: 12px;\n}\n\n.current-number-display {\n  min-width: 100px;\n  /* width: 120px; */\n  /* height: 120px; */\n  background-color: #f8f9fa;\n  border-radius: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.current-number-display span {\n  font-size: 48px;\n  font-weight: 700;\n  color: #2c3e50;\n}\n\n/* Clinic Status Section */\n.clinic-status-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n}\n\n.status-control {\n  display: flex;\n  flex-direction: column;\n}\n\n.reset-button {\n  height: 40px;\n  font-weight: 500;\n  background-color: #f8f9fa;\n  color: #e74c3c;\n  border: 1px solid #e74c3c;\n  border-radius: 8px;\n}\n\n/* Message Section */\n/* .message-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* .active-message {\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.message-content {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.message-close {\n  color: #e74c3c;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n}\n\n/* .message-close:hover {\n  background-color: #f5e0e0;\n}\n\n.message-text {\n  flex: 1;\n  color: #2c3e50;\n}\n\n.message-time {\n  display: block;\n  margin-top: 4px;\n  font-size: 12px;\n  text-align: right;\n} */\n\n/* Business Type List Styles */\n.business-type-container {\n  padding: 20px;\n  max-width: 100%;\n  margin: 0 auto;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.section-title {\n  color: #2c3e50;\n  margin-bottom: 16px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.scrollable-row-container {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px;\n}\n\n.scrollable-row1 {\n  display: flex;\n  flex-wrap: wrap;\n  margin: -8px !important; /* Counteract the gutter */\n}\n\n/* Fix for antd Row/Col with scrolling */\n.scrollable-row1 > .ant-col {\n  padding: 8px !important; /* Recreate gutter */\n}\n\n.business-type-card {\n  cursor: pointer;\n  border-radius: 12px;\n  border: 1px solid #e8e8e8;\n  transition: all 0.3s ease;\n  height: 140px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8f9fa;\n}\n\n.business-type-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);\n  border-color: #1890ff;\n}\n\n.card-content1 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 16px;\n  width: 100%;\n  margin-left: -15px;\n}\n\n.business-icon {\n  font-size: 32px !important;\n  color: #1890ff;\n  margin-bottom: 12px;\n  padding: 8px;\n  background-color: #e6f7ff;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.business-title {\n  color: #2c3e50;\n  font-size: 16px;\n  text-align: center;\n  margin-top: 8px;\n  word-break: break-word;\n}\n\n/* Custom scrollbar styling */\n.scrollable-row-container::-webkit-scrollbar {\n  width: 8px;\n}\n\n.scrollable-row-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.scrollable-row-container::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n.scrollable-row-container::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .business-icon {\n    font-size: 28px !important;\n    width: 50px;\n    height: 50px;\n  }\n  \n  .business-title {\n    font-size: 14px;\n  }\n}\n\n@media (min-width: 768px) {\n  .queue-management-panel {\n    max-width: 60%;\n  }\n  .results-header {\n    max-width: 60%;\n    /* margin-left: 20%; */\n  }\n}\n@media (min-width: 1024px) {\n  .queue-management-panel {\n    max-width: 60%;\n  }\n  .results-header {\n    max-width: 60%;\n    /* margin-left: 20%; */\n  }\n}\n@media (min-width: 1440px) {\n  .queue-management-panel {\n    max-width: 60%;\n  }\n  .results-header {\n    max-width: 60%;\n    /* margin-left: 20%; */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
